import { render, staticRenderFns } from "./appraisalAddStudent.vue?vue&type=template&id=84b83d06"
import script from "./appraisalAddStudent.vue?vue&type=script&lang=js"
export * from "./appraisalAddStudent.vue?vue&type=script&lang=js"
import style0 from "./appraisalAddStudent.vue?vue&type=style&index=0&id=84b83d06&prod&lang=less"
import style1 from "./appraisalAddStudent.vue?vue&type=style&index=1&id=84b83d06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports